// 定数
export const API_STATUS_INITIAL = 0;
export const API_STATUS_200 = 200;
export const API_STATUS_400 = 400;
export const API_STATUS_401 = 401;
export const API_STATUS_403 = 403;
export const API_STATUS_404 = 404;
export const API_STATUS_500 = 500;
export const API_STATUS_503 = 503;

export const REQUEST_METHOD_GET = "GET";
export const REQUEST_METHOD_POST = "POST";
export const REQUEST_METHOD_PUT = "PUT";
export const REQUEST_METHOD_DELETE = "DELETE";

// コピーライト
export const COPY_RIGHT = "Copyright (C) MCD3 Inc. All Rights Reserved.";

// BFFサービスURL
export const BFF_SERVICE_ENDPOINT_FOR_LOCAL = "http://localhost:4000";
export const BFF_SERVICE_ENDPOINT_FOR_T2 = "https://bff-api.t2.skillmap-site.kensetsu-site.com";
export const BFF_SERVICE_ENDPOINT_FOR_S2 = "https://bff-api.s2.skillmap-site.kensetsu-site.com";
export const BFF_SERVICE_ENDPOINT_FOR_P2 = "https://bff-api.p2.skillmap-site.kensetsu-site.com";

// ヘッダーロゴ
export const PRIME_HEADER_ROGO = "data:image/png;base64,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";
export const PARTNER_HEADER_ROGO = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANQAAAAoCAYAAACGjtR6AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAABPBSURBVHhe7Z1rtFXVdcfnvXAfPL1AYgpiBIxgNCm+csUXoNEaREGteRBpDB/Ih3aMRkab0Tap+IhmJCMdVT9kZLQOq44SqRGjaIjpSCpYFQsmokmNQY1oVMQGeShyL3Dvpf/fOnse9zl3n3P2Pg9Acv6MOfbea6+19tprzf+cc629zqVl//79lhUtLS3RWRNNNBFHa3Rsookm6oAmoZpooo5ohnxNNBzT7r5ttg4nSR7Y+MXFr4TEwxSZCDVt+W3H6jBHcpnkDMkwCeiRPCl5UPLjjQsW/47ENGiS8/CGyHSnDlflrgIuE6keiM4PO1QklEjE4RLJlZLTJUdLhkiS0C95TbJO8gPJQyKXDqVxKBFKg9+lwxoJlvS6kFgFVM9JKv9MdBmgtEk6dBWnH86gH3TYIHlWArFuljyqPsBj5aF8t+jwjNLJkwjluVoH+q/qcSmG6mS8qW+N6s2TPGo3bfqy0jN51LKEEplm6nCT5OyQEEOL/u0dgD9m7a1DbL/+JeAxyTdEKo6JyEKoqAN42VIovv9KuUEqRtSRKICpXFVMVx0MxFclBZZY6Tt0OEJystL/KEild4Y4qyV3SSAE782YFBMqKE+5Pk+TJwtUnxvP6ZJXVS8GL0D3SJ8luV7pmQhcklAi0/U6XCMpeAEuBlRm+949dvSIkSHttfd22Zj2DmsVORJqI+mbItW1uctCZCQUCjo/d5Uar0quVsekCjN84IRzVYaOLYDuQ7odupdouUoNRqV6Hcr3ZR2QakG77iz3jCxQe1C0vLJlBEaEfj9GslOCQRmkpN43Sj8ghFJdcTKBRao3b3h1P3EM02DQKp+I1CpZptOlkkFk2iki7erbZ4umfdJ+dskXgnBOGvcS3pakpdRJ3bmkqsFLP5pSCDMAg3lp7jQVKAsuVcci10kekDwjYVDxYI30MFhyBrNaYb6yWm2tlgTF4F3xMtUIfYXHxkNRz5KsClpvRP1Skky1osBDSeE5/LtkISd9ujdUHgQv0rNvn70n0syacLRde9pZNq5zmF3/iyfIFq7f7u3V9eP26ObXbMTQNhvW1mYJ3g+i/kV8XtXIOZQ6D2sNoRItje57iOhW2FejsKSlgKXFA6D4g6A6E62b0r0zKnmoSmFtOeDZfAGg5HP0DOon9MKDlIXy8p5ZDBLgHVxhV+o5BeVVJ9fxd/TohaioFJLyMO9KFXkAPZfxJb+PbyKZlK9qD1VMKBqLZwphXeeQodbb32fb9vTasUd02T+ecqadM36i3fHbX9v3nttgO5QOujo67a9OPMUWHf8Je+zN1+2mp9faizu3KwzstLbW1uIwkPAvPAM0ilDRoN2fuypULt1jMLkuRxyAtyIfxEQBExU0jlKDofRUhKoFegbKEQilZ4SOVVowFv7M6BpvQdjKeQF0n76h3UzIKxKuFFSPh+cFixDR8zflruqCyaq/7MKBngnBeSfmtgCjOFvlEiMN5U8cwzTIh2Ai01k6BEVnJPb099uN3efYhOEj7WsnddvqeQtC5jmr7rUbf7nW3lF4B2EQzm/85RPhHnkeuWSBXXfa2WFOBRnRpBhtrtGzzozOGwnvCAa0WIEZVCcToeFKCcaEzwGI41I6VFK3OUmjICVAad073RodASEXIWCYl+k9UD6IcoynFYH8ECGrVyqFAlJGz18kob9dHPG0YnHE01j4qUQm3gPiOJkwkhiYRDIVYZLKDzI65RA81NTltw0REdb29vd345He3bfXuj883lbPX2Df3rDOhogNT2x5wx7+/csh1OsbGLAzPjLBvnFqjhc3iWBrt2wOrOnfP2DnHXWMyDjTRir0+/Yz6+y+321UHS02qq3dBnL+ar3kLHmqvkZ4KHUCYQpLtCCzR1B5lADCZf5morKJ1k3pmT2UykASBr9sjK98WGAUizZjILC+QZF1jzYQLj2rtBBmJaU5dI96CJNr8qSqx/uwopVX3tA3yldSGdLkiUP56Tuey1jEUfG9VNbH0OHL/hU/TAcPpRZeuG9goPuEMePssslTbeFxJ9jS03JkWTj1BPvfbVutQ+HfvEkfCyHcd88411bO+XPrPnJ8EM5vOfvTNmV0V/BEa9541WavvNtu/fUv7OunzLAVF863j3eNs96BvlCn0C25MHdaX6gzPGQBt1bqvBLwMgXK5tAzuqIBK4cCy1wlIPMdelZJQtEWHWgvyksoUxyq4XHA9KhvQDwtb4GjuiATSGPBE6F66BuPADIZpFrBsyX0B4siTgoikFrAfBADvUl1szh1tYS+GoRAKFF/UZ88y1CRhTDvX2Z9xs6VlwETR4yyu86ba/dcMM8+MnyE/c30brtq2ifCvTiuFAl/dvHnbcn0T9mYjpwXu11zrZkP3G27+vrsH06dETwf368i1LI0nIjoJVE+BpPl8rKWsQxcmVjlY4DowFskayQo63YJYZQrZhyuoFUrZAy+8HFV9OyCQdQ1z0J5fAFg0LwgIherbCDUF6W5ksVDOz/Hc9ViEHxs+b5Tj34oC/pBwhjhPeJEIrzDI1UbvhJWniwhhEafgJNru553p6TAsLYq3DtGKj5jmDzQU//3pp3/0D22Yetb0e0ctux+z656ZJVNH3uk/fUnT41SB2N0e3tYuHjooits/uTjbFxHp23t3W0/fOl5hYL742QCMzSXyhSfloNezC21K1fqSbXKMiAQhyVyCOkDQF0MEB1IDM5AueUlDHBPFodb+NSInv+KpICgaj9tYb4BeHb+ecrLQKKstBHPhOKUUl73EnHFom7Kxcv4/aT3SgW1Cy/oc7lqDVoBondNhO4x7rwDY+R9j7GgPzAwVb8LoE8lfMdEV8+VuHEC/okCYxf0rlUqPk/H8QSorNaxOsdcKY71Itro9g5bfILrankc3zXWbp89xyaNHm0DA/ttJHOnwUvo4yVzc6e1IerUOJkA1qNcyMZ9OoKGseoEcZhX0EnxeooXLdjp0CJhe1FBOFP0vCyWGcVDGQa1V8+Ik4oQjXaTn/Z6mFdWcaJ28h75+J80CVt5QjnVicL4R/Mkz5sWtBfgnfy8VrjhdS9RDN6Le4wRq34sJtVEpCRQpwTvO0bCs+h7gLHjOoR8l0vC3jyUnoWDOR+dEjzK7c//yl7aucMuOHpSWLEjLS3IObSFLUklwTOvyJ1Wj0gR4mTyF0VBIUxSaEkaxPHQABAeYH0ojyVCAcEt0QCx2ocSliOKW1KUKa13jFv0RAVUXaSHARPI699kUq9YKQ8GINHARHASsSpaduJdCnoX2unjkPidrgSWSNxoJMH7dRBJ1FaW/3k3+oExqqrtWRA9k2dhyGk34xCMK4Riw2vAPs17Jo4cZb/Z9rbNXXWvXf3Ez23ewyvs30Ss7b099tqud6KclQE5S21riiH/7GqgASREQZl8EPlQh/VmACAEFpxJfUHooTwoDx0BccboGo+DlSdMpKMYOFfSkuFGApy85axjnmhqFwPiJGLeUtKi0y4d4uFG+L4jqWWuE6B20G73TlmIkEdEJjcMLAalXoxQXoxW4rurXgym11t3r1MraLeEcQjth1D+E4ywgveHnt329NYtNrytLazsHTViVPj4umegP2yCrTPyz84COllC5/Lh1sMeYubwUjpCBicVuDYa8DyijsCFl1JIH7xyVj0P1Q+5ndiJygGitpEfMkFsytD+JE9aAJUlD9YQzFIdWcieCNVBnXfkrsISd0VvFwfvIaGvXOnvUh1VkbIYUR85MesZQjYMYZXPwaIBK3EsKEwZ1WW9fX2BZH954sl2zwXzbUK0GfZgQR0MkehU5jwerjG/ye8EcOgaosRJxUpZlrmBKxbzFga2JGiXDj7YSR+S81DekyS0K66ETHrTKjLE9bkEewx9fpEJvJMEZXUyQYQCT14JKg9xCLF8LKijomFIA9WNIaOP3EjFF1QOWUAofhyYB3OlHhGJ8A/PROiWZe6UEQXPLodo8CGSKyFKxYdX5jeJXiZKj5Pqq9FAVYTKxhW8ZJnYwLunrKRQbBhlQcE9U6bNmdE7uXLxzExWW+3FKGFYIIKHeXimVESIyrMaSnlW1vy92fhaM5lULwaHd6Kf4n2UyXMeLEAofgx4sJDq2epgSOGDD5HoYLxSxThdeZxUlGNwEslXAh5eUb4UaIMv1+JpSk2KvS4H1/nYOwtUBuViIg9SGQigfqQcRolPABCBNhAqV/RMKguRvDyLIv7OzOtYFMji/QdBdUMkxgYiudGsuo8OFiDUCknul4JFwC8NaWkN24aygjKULePbeOZ9udPyUIfiAXzJuuJWnGIof9gIKmGZOMsqkD+nnHUkDx4Qb1muXXgVFkJ4D5Z2UZSqra7KosDUlTUUwqhAgqzfafA+Hn5RBx87eY/Mv2otAQ+ri9tXdR8VgToZpzT1MY60I/OzW467+1/5sPu4zicyh3p7T48t+/TFdv/LL9oPX/6tHTV8pP39KafblcedmCuREstefM6+8/Q6e2P3LvvcscfbZZqXLfyvH9u4jmEiWaDZ65JzXvjiV+oxGA0DlrOOg/qBhfoBhYdULOQc9v3B++o9s0QzAS3R5th7RaorINTWPbtt5Wcutye3bLZr1v+3je0cFuZTZ/7JUfa307vt7PETo6LJePzN1+2fnl0fNtO2t7batt4e++bpM8Nm2vk//ZF9qGO4E2rFxgWLP9vI30M10cSBRiDUtOW3XaTzVSTwy9vPTZlm3zp9lq3Z/PvwI8KNO7bZ0NYW62gdapdPmWpL/vRTNnk0Ifj72PTOTrv5V0/Zj15+wfYM9FnfgOrtGht+fDh7wkft6+selcfbGHagR7hYhFqVhVCyGlhIX9XCSoZlb6WHsEXng+Y6eBgdCI/CSpqumfMQSvgGVxYICC/Shj4NR9RmD+Xw4LwnW5P8XeoVZjVRZ4Rlc/mL/9SBn1SEnRLLX3rezntwedjg+vDcz4ad56PbOqynv89+8OJv7KKf3Gv//OxT4TdTCOekcY885KUMZamDuqiTuiPwLJ6ZClIklB8CscTLhBjhG1SaCTl5WNb1vIQuhdbgEILek/idibm/J+/sq2cYAN4lGI6oX9i0W/PqWhP1QSDUCwsWs0AQVo3wWF3tnfbGe7ts0eqf2FfW/DT8vonfRn3hYx8PCw1be3bbt55+0i55+D7JinBOGvfIQ17KUJY6qIs6YzsnlvBbqOg8DbDWTIiZWLKPih3AbMWpaKVlyVFQJs/lFgwOCUAQHVjhYkVyciQsZLgHxjvF3wUjwYpdVd+imqg/QsjniP8EHhCM7dy7N+ygXTj1RPu7k2fYK+/utKXrH7O1b222tihc26c6ztQc6Ybuc2zSqCPsOxv+x5a98Jwp6rMj2ttzM6b3cYPIhOUNSBPySdFY1qUM3zoGLc/qfj7k07mHRWGXcOzaQz7yztJ5i84LQr7onpOUe3hFPl7iAfwjJuFWmJQrP2nkY0mfFaRwT+nkR0J4KaENvAN7AUtOdFUOYrAsXfCzcUesXt+JALEwNBCQtuU/EEd5eSbp7Ao55A3K4YDgoWJAafkDlQEQAULwR1fYz3fW/ctswx/esuUXzLPvz/wz+/Cw4UE4J4175CEvZRLIRN15MmWAK8PNUhR2WydaZKWjuJCCo5fB6hMm+bJsOZAPD+FkgigoOMrJNcob/2bDh02ehUJzz7+L0T7q4r4/l9Ct7HczKT3KDzHZVgTBi0nl9ZZ6l0BWlaOtPI/6KDNoP2MTjUEBoeQ5OHxJUkAqvMi4zuFhvvS1J1fb3FUrbExHpz0yb0GQsTonjXvkIS9lEsj0pegZmRApGhtZUVwU3r1AHChO8FRCrd94+GZFmMnzAPWh3Hyb8A/MgDaRjsfgnn/sdLAVh7K0jbogAwofFkTiQnoEztlORV5+a8P2okEEUp28X95TRc9h4YLykJuPopDI88Sf0USDUOyhINWAhD8jdoMkzwmWutnXd+SwEbbp3R228OcP2dKnHgtypc5J417urxwVUIkLwryF1J1Lyg4pCytdKKZv88fqxj9qoswsNrAVqWoyCfEdDcFjoKi5y/c/9EVKTiiJB/NNusWIh1mB7JHC49UINeMSoGfxEZr38p+QQOAs3oW6QSCkxP/yUxMHAIMI5ZDyE5oxKAV/RhmyDFc4h4d6cNNLQTgnrYhIgLKzorrqAikbSureyZUH4CEAq15pwru0KDXnQcnxBOwYQPlZMClGvB3eVuZ2GAd+MpKX6F4e5NEB8vFexd64HLy9YbdBTNxTNdFAlCQUEBEgBH/fnF/1/ocES53fpjRKcyQkBu6Rh7yUmRnVURNEEBYXwu/3Iwvvnimu7HgPVipRcuYf9SRVErx+FJ9z338WB5tIaTPKTLvK/vBQ+djPRtvD37JQEu+J5yvlcb0uyjlh82GvhHaRh3rw7k00GGUJBUQIhP9FY4Euz5egHI9I4jvFOSeNe+eTNyrDvXrAFdbDI84JhwpWrqSshGBY5kAq0hoIX20kpELcQ8aBEtNeFicIJeMhahJ4T6IC6qMcCwvUm+hd9L4QjbkZYeEGSKg0DBqGhbqoh29aLK1z3USDUbBsnhYHY7tQZLERQMiUJ4xb50jBPG8Im3SOInGfUItdFZyHv6WQcI9yzGG8nuJ682Wja8oTjuVX96J6CQcJcwm1IFWqvzoLomcglOO5YTeIjtwjLaQXpUFUiJTPC3SPtnFdkN5E41AVoWrBwSDjgYYUGTJBKjxGfJHjA4kDrSMfZFQM+Zpooon0aBKqMWBuR/gYQsUm/lhg9v/FacgosFi3qgAAAABJRU5ErkJggg==";

// メンテナンス情報ページURL
export const URL_MAINTENANCE_INFO = "https://portal.kensetsu-site.com/portal/"

// 建設サイト・シリーズ サービス約款同意画面
export const URL_KENSETSU_SITE_SERVICE_TERM_FOR_T5 = "https://t5.portal.kensetsu-site.com/portal/data_cooperation_agree"
export const URL_KENSETSU_SITE_SERVICE_TERM_FOR_S2 = "https://s2.portal.kensetsu-site.com/portal/data_cooperation_agree"
export const URL_KENSETSU_SITE_SERVICE_TERM_FOR_P2 = "https://portal.kensetsu-site.com/portal/data_cooperation_agree"
// 建設サイト・シリーズ サービス約款PDF
export const URL_KENSETSU_SITE_SERVICE_TERM_PDF = "https://gs.kensetsu-site.com/helpdesk/public_file/service_yakkan.pdf"
// 建設サイト・シリーズ オーナー約款PDF
export const URL_KENSETSU_SITE_OWNER_TERM_PDF = "https://gs.kensetsu-site.com/helpdesk/public_file/owner_yakkan.pdf"
// お問い合わせフォームURL
export const URL_CONTACT_FORM = "https://forms.office.com/r/xUcRaAciwZ/"
// スキルマップマニュアルURL
export const URL_SMS_MANUAL = "https://manual.kensetsu-site.com/skillmap/"

// BFF URL
/** 認証 */
export const URL_AUTH = "/auth";
/** 認証コールバック */
export const URL_AUTH_CALLBACK = "/auth/callback";
/** ログアウト */
export const URL_LOGOUT = "/logout";
/** ログインユーザー情報取得 */
export const URL_CMN_USERS_ = "/cmn/users";
/** 約款取得・編集 */
export const URL_CMN_TERMS = "/cmn/terms";
/** 自企業支店一覧取得_元請 */
export const URL_CMN_PRIME_BRANCHES = "/cmn/prime/branches";
/** 独自資格一覧取得 */
export const URL_QUALIFICATIONS_PRIME_LIST = "/qualifications/prime/list";
/** 独自資格一覧編集・削除 */
export const URL_QUALIFICATIONS_PRIME_INFO = "/qualifications/prime/info";
/** 個人の有効独自資格取得 */
export const URL_QUALIFICATIONS_HOLDERS_PARTNER_QUALIFICATION_LIST = "/qualifications-holders/partner/qualification-list";
/** 個人の有効独自資格取得 */
export const URL_QUALIFICATIONS_HOLDERS_PRIME_QUALIFICATION_LIST_SUBMIT = "/qualifications-holders/prime/qualification-list-submit";
/** 独自資格保有者所属会社一覧取得 */
export const URL_QUALIFICATIONS_HOLDERS_PRIME_COMPANIES = "/qualifications-holders/prime/companies";
/** 独自資格保有者一覧取得_元請 */
export const URL_QUALIFICATIONS_HOLDERS_PRIME_LIST = "/qualifications-holders/prime/list";
/** 独自資格保有者編集・削除 */
export const URL_QUALIFICATIONS_HOLDERS_PRIME_INFO = "/qualifications-holders/prime/info";
/** 独自資格保有者対象者取得 */
export const URL_QUALIFICATIONS_HOLDERS_PRIME_WORKERS = "/qualifications-holders/prime/workers";
/** 勤怠実績集計取得_元請 */
export const URL_ATTENDANCE_PRIME_SUMMARY = "/attendance/prime/summary";
/** 勤怠明細取得_元請 */
export const URL_ATTENDANCE_PRIME_DETAIL = "/attendance/prime/detail";
/** 勤怠実績報告 作業者別勤怠実績管理_一覧 */
export const URL_ATTENDANCE_PRIME_WORKER_SUMMARY = "/attendance/prime/workers-summary";
/** 勤怠実績ステータス変更 */
export const URL_ATTENDANCE_CMN_STATUS = "/attendance/cmn/status";
/** 勤怠実績集計取得_協力 */
export const URL_ATTENDANCE_PARTNER_SUMMARY = "/attendance/partner/summary";
/** 勤怠明細取得_協力 */
export const URL_ATTENDANCE_PARTNER_DETAIL = "/attendance/partner/detail";
/** 勤怠編集_協力 */
export const URL_ATTENDANCE_PARTNER_DAILY = "/attendance/partner/daily";
/** 勤怠検索条件取得_協力 */
export const URL_ATTENDANCE_PARTNER_SEARCH_CONDITIONS = "/attendance/partner/search-conditions";
/** 承認依頼メール送信_元請 */
export const URL_ATTENDANCE_PRIME_SENDAPPROVEREQUESTMAIL = "/attendance/prime/sendApproveRequestMail";
/** 一括承認予約_元請 */
export const URL_RESERVE_BULK_APPROVAL = "/attendance/prime/reserve-bulk-approval";
/** 一括承認予約取消_元請 */
export const URL_CANCEL_BULK_APPROVAL = "/attendance/prime/cancel-bulk-approval";
/** 勤怠管理グループ一覧取得_元請 */
export const URL_ATTENDANCE_PRIME_MANAGEMENT_GROUP_LIST = "/attendance/prime/management-group-list";
/** 作業員氏名一覧取得 */
export const URL_ATTENDANCE_CMN_WORKER_NAME_LIST = "/attendance/cmn/worker-name-list";
/** 廃止企業一覧取得 */
export const URL_ATTENDANCE_CMN_ABOLISH_COMPANY_LIST = "/attendance/cmn/abolish-company-list";
/** 保有者一覧帳票出力 */
export const URL_REPORT_PRIME_QUALIFICATIONS_HOLDERS = "/report/prime/qualifications-holders";
/** 手当支払帳票出力_元請 */
export const URL_REPORT_PRIME_PAYMENT = "/report/prime/payment";
/** プロジェクト別手当支払帳票出力_元請 */
export const URL_REPORT_PRIME_PROJECT_PAYMENT = "/report/prime/project-payment";
/** 勤怠実績帳票出力_協力 */
export const URL_REPORT_PARTNER_ATTENDANCE = "/report/partner/attendance";
/** 勤怠実績サマリ帳票出力_協力 */
export const URL_REPORT_PARTNER_ATTENDANCE_SUMMARY = "/report/partner/attendance-summary";
/** 手当支払い金額確認帳票出力前処理_協力 */
export const URL_REPORT_PARTNER_PAYMENT_PRE = "/report/partner/payment-pre";
/** 手当支払い金額確認帳票出力_協力 */
export const URL_REPORT_PARTNER_PAYMENT = "/report/partner/payment";
/** 権限一覧取得・編集_元請 */
export const URL_CMN_PRIME_AUTH = "/cmn/prime/auth";
/** 権限一覧取得・編集_協力 */
export const URL_CMN_PARTNER_AUTH = "/cmn/partner/auth";
/** 利用可能協力会社一覧取得・編集・削除 */
export const URL_CMN_PRIME_AVAILABLE_PARTNER_COMPANIES = "/cmn/prime/available-partner-companies";
/** プロジェクト一覧取得 */
export const URL_CMN_PRIME_PROJECTS = "/cmn/prime/projects";
/** プライムプロジェクト情報取得 */
export const URL_CMN_PRIME_PROJECTS_ALL = "/cmn/prime/projects-all";
/** 協力会社一覧取得 */
export const URL_CMN_PRIME_PARTNER_COMPANIES = "/cmn/prime/partner-companies";
/** 基本設定取得_元請 */
export const URL_COMMON_SETTING_PRIME_LIST = "/common-setting/prime/list";
/** プロジェクト別勤怠実績（確認・承認権限保持）ユーザ取得 */
export const URL_CONFIRM_APPROVAL_USERLIST = "/cmn/prime/auth/userlist";
/** 建退共連携_プロジェクト一覧取得_元請 */
export const URL_MUTUAL_AID_PRIME_LIST = "/mutual-aid/prime/list";
/** 建退共連携_プロジェクト詳細_元請 */
export const URL_MUTUAL_AID_PRIME_DETAIL = "/mutual-aid/prime/detail";
/** 建退共連携_ステータス変更_元請 */
export const URL_MUTUAL_AID_PRIME_STATUS = "/mutual-aid/prime/status";
/** 建退共約款同意状況_協力 */
export const URL_ATTENDANCE_PARTNER_MUTUAL_AID_TERMS_AGREE = "/attendance/partner/mutual-aid-terms-agree";
/** 建退共約款同意状況_元請 */
export const URL_MUTUAL_AID_PRIME_TERMS_AGREE = "/mutual-aid/prime/terms-agree";
/** 建退共連携_連携結果一覧取得_元請 */
export const URL_MUTUAL_AID_RESULT = "/mutual-aid/prime/result";
/** 建退共連携_連携結果一覧ダウンロード_元請 */
export const URL_MUTUAL_AID_RESULT_DOWNLOAD = "/mutual-aid/prime/result-download";
/** 建退共連携_連携結果詳細取得_元請 */
export const URL_MUTUAL_AID_RESULT_DETAIL = "/mutual-aid/prime/result-detail";
/** 建退共連携_連携結果エラーレポート添付_元請 */
export const URL_MUTUAL_AID_ERROR_REPORT_ATTACH = "/mutual-aid/prime/error-report-attach";
/** 建退共連携_連携結果エラー変更_元請 */
export const URL_MUTUAL_AID_ERROR_REPORT = "/mutual-aid/prime/error-report";
/** 建退共連携_連携結果エラーレポート表示_元請 */
export const URL_MUTUAL_AID_RESULT_ERROR_GET  = "/mutual-aid/prime/result-error-get";


// 画面パス
/** トップ*/
export const PATH_TOP = "/top";
/** 利用終了*/
export const PATH_USE_END = "/useEnd";
/** システムエラー*/
export const PATH_SYSTEM_ERROR = "/systemError";
/** 404エラー */
export const PATH_NOT_FOUND_ERROR = "/notFoundError";
/** 権限エラー元請 */
export const PATH_PRIME_PERMISSION_ERROR = "/primePermissionError";
/** 権限エラー協力 */
export const PATH_PARTNER_PERMISSION_ERROR = "/partnerPermissionError";
/** メンテナンス */;
export const PATH_SYSTEM_MAINTENANCE = "/systemMaintenance";
/** 緊急メンテナンス */
export const PATH_EMERGENCY_SYSTEM_MAINTENANCE = "/emergencySystemMaintenance";
/** 認可エラー（プライム未契約エラー：元請） */
export const PATH_PRIME_NO_CONTRACT_ERROR = "/primeNoContractError";
/** 認可エラー（利用対象未設定エラー：協力） */
export const PATH_PARTNER_NOT_SET_USER_ERROR = "/partnerNotSetUserError";
/** 無償MCDP-IDエラー */
export const PATH_FREE_MCDP_ID_ERROR = "/freeMcdpIdError";
/** 勤怠実績報告 一覧*/
export const PATH_PRIME_ATTENDANCE_SUMMARY = "/prime/attendance/summary";
/** 勤怠実績報告 作業者別明細*/
export const PATH_PRIME_ATTENDANCE_DETAIL = "/prime/attendance/detail";
/** 勤怠実績報告（作業者別）一覧*/
export const PATH_PRIME_WORKERS_ATTENDANCE_SUMMARY = "/prime/workers-attendance/summary";
/** 勤怠実績報告（作業者別）明細*/
export const PATH_PRIME_WORKERS_ATTENDANCE_DETAIL = "/prime/workers-attendance/detail";
/** 独自資格保有者 協力会社一覧*/
export const PATH_PRIME_QUALIFICATIONS_HOLDERS_COMPANIES = "/prime/qualifications-holders/companies";
/** 独自資格保有者 一覧*/
export const PATH_PRIME_QUALIFICATIONS_HOLDERS_LIST = "/prime/qualifications-holders/list";
/** 独自資格保有者 登録*/
export const PATH_PRIME_QUALIFICATIONS_HOLDERS_ADD = "/prime/qualifications-holders/add";
/** 独自資格保有者 詳細*/
export const PATH_PRIME_QUALIFICATIONS_HOLDERS_DETAIL = "/prime/qualifications-holders/detail";
/** 独自資格保有者 編集*/
export const PATH_PRIME_QUALIFICATIONS_HOLDERS_EDIT = "/prime/qualifications-holders/edit";
/** 独自資格 一覧*/
export const PATH_PRIME_QUALIFICATIONS_LIST = "/prime/qualifications/list";
/** 独自資格 登録*/
export const PATH_PRIME_QUALIFICATIONS_ADD = "/prime/qualifications/add";
/** 独自資格 詳細*/
export const PATH_PRIME_QUALIFICATIONS_DETAIL = "/prime/qualifications/detail";
/** 独自資格 編集*/
export const PATH_PRIME_QUALIFICATIONS_EDIT = "/prime/qualifications/edit";
/** 建退共掛金管理 プロジェクト一覧*/
export const PATH_PRIME_MUTUAL_AID_PROJECT_LIST = "/prime/mutual-aid-project/list";
/** 建退共掛金管理 プロジェクト詳細*/
export const PATH_PRIME_MUTUAL_AID_PROJECT_DETAIL = "/prime/mutual-aid-project/detail";
/** 建退共掛金管理 連携結果の外部出力*/
export const PATH_PRIME_MUTUAL_AID_RESULT = "/prime/mutual-aid-project/result";
/** 建退共掛金管理 連携結果の外部出力明細*/
export const PATH_PRIME_MUTUAL_AID_RESULT_DETAIL = "/prime/mutual-aid-project/result-detail";
/** ユーザ権限管理 一覧*/
export const PATH_PRIME_AUTH_LIST = "/prime/auth/list";
/** ユーザ権限管理 一覧編集*/
export const PATH_PRIME_AUTH_EDIT = "/prime/auth/edit";
/** 協力会社一覧*/
export const PATH_PRIME_PARTNER_COMPANIES = "/prime/partner-companies";
/** 勤怠実績報告 支店一覧*/
export const PATH_PARTNER_ATTENDANCE_SUMMARY = "/partner/attendance/summary";
/** 勤怠実績報告 作業者別明細*/
export const PATH_PARTNER_ATTENDANCE_DETAIL = "/partner/attendance/detail";
/** 勤怠実績報告 支店一覧*/
export const PATH_PARTNER_ATTENDANCE_MOBILE_SUMMARY = "/partner/attendance-mobile/summary";
/** 勤怠実績報告 作業者別明細*/
export const PATH_PARTNER_ATTENDANCE_MOBILE_DETAIL = "/partner/attendance-mobile/detail";
/** 勤怠帳票出力*/
export const PATH_PARTNER_REPORT_DOWNLOAD = "/partner/report/download";
/** ユーザ権限管理 一覧*/
export const PATH_PARTNER_AUTH_LIST = "/partner/auth/list";
/** ユーザ権限管理 一覧編集*/
export const PATH_PARTNER_AUTH_EDIT = "/partner/auth/edit";
/** ユーザ権限管理 一覧編集*/
export const PATH_PRIME_REPORT_DOWNLOAD = "/prime/report/download"
/** 基本設定管理 一覧*/
export const PATH_PRIME_SETTING_LIST = "/prime/setting/list";
/** 基本設定管理 一覧*/
export const PATH_PRIME_SETTING_EDIT = "/prime/setting/edit";


/**
 * CCUSレベル
 */
export const CCUS_LEVEL_MIN = 1;
export const CCUS_LEVEL_MAX = 4;

/**
 * 次数範囲
 */
export const HIERARCHY_LEVEL_MIN = 1;
export const HIERARCHY_LEVEL_MAX = 5;

/**
 * カレンダー日付範囲
 */
export const DATE_PICKER_RANGE_MIN = "2000";
export const DATE_PICKER_RANGE_MAX = "9999";

/**
 * スキルマップ稼働時刻
 */
export const SMS_START_HOUR = 7;
export const SMS_END_HOUR = 22;

/**
 * 入力チェック
 */
export const QUALIFICATION_NO_MAX_LENGTH = 20;
export const QUALIFICATION_NAME_MAX_LENGTH = 50;
export const DAILY_ALLOWANCE_TIME_MAX_RANGE = 24;
export const DAILY_ALLOWANCE_TIME_MIN_RANGE = 1;
export const DAILY_ALLOWANCE_TIME_MAX_LENGTH = 2;
export const MONTHLY_ALLOWANCE_DAYS_MAX_RANGE = 31;
export const MONTHLY_ALLOWANCE_DAYS_MIN_RANGE = 1;
export const MONTHLY_ALLOWANCE_DAYS_MAX_LENGTH = 2;
export const ALLOWANCE_AMOUNT_MAX_LENGTH = 6;
export const ALLOWANCE_AMOUNT_MAX = 999999;
export const ALLOWANCE_AMOUNT_MIN = 0;
export const REMARKS_MAX_LENGTH = 400;
export const REMARKS1_MAX_LENGTH = 400;
export const REMARKS2_MAX_LENGTH = 400;
export const COMPANY_NAME_MAX_LENGTH = 100;
export const COMPANY_NAME_KANA_MAX_LENGTH = 100;
export const PRIME_CERTIFICATION_NO_MAX_LENGTH = 20;
export const NAME_MAX_LENGTH = 20;
export const WORKING_TIME_MAX_LENGTH = 5;
export const PROJECT_NAME_MAX_LENGTH = 100;
export const BRANCH_NAME_MAX_LENGTH = 100;
export const AUTHORITY_MCDP_ID_MAX_LENGTH = 8;
export const LAST_NAME_MAX_LENGTH = 20;
export const FIRST_NAME_MAX_LENGTH = 20;
export const LAST_NAME_KANA_MAX_LENGTH = 20;
export const FIRST_NAME_KANA_MAX_LENGTH = 20;
export const CCUS_CRAFTSMAN_ID_MAX_LENGTH = 14;
export const MANAGEMENT_GROUP_NAME_MAX_LENGTH = 100;
export const MANAGEMENT_GROUP_NAME_KANA_MAX_LENGTH = 100;
export const MANAGE_BRANCH_NAME_MAX_LENGTH = 100;
export const MANAGE_BRANCH_NAME_KANA_MAX_LENGTH = 100;
export const PASSWORD_MAX_LENGTH = 20;
export const COMMENT_MAX_LENGTH = 300;
export const TOP_HIERARCHY_LEVEL_MAX_RANGE = HIERARCHY_LEVEL_MAX;
export const TOP_HIERARCHY_LEVEL_MIN_RANGE = HIERARCHY_LEVEL_MIN;
export const TOP_HIERARCHY_LEVEL_MAX_LENGTH = 1;

// 処理区分
/** 登録*/
export const PROCESS_TYPE_ADD = "1";
/** 編集*/
export const PROCESS_TYPE_EDIT = "2";

/** 勤怠処理種別 */ 
export enum ATTENDANCE_PROCESS_TYPE {
    /** 勤怠処理種別：承認 */
    APPROVAL = "1",
    /** 勤怠処理種別：確認 */
    CONFIRM = "2",
    /** 勤怠処理種別：差戻 */
    REMAND = "3",
    /** 勤怠処理種別：提出取消 */
    SUBMIT_CANCEL = "4",
    /** 勤怠処理種別：提出 */
    SUBMIT = "5",
    /** 勤怠処理種別：承認取消 */
    APPROVAL_CANCEL = "6",
    /** 勤怠処理種別：強制承認 */
    FORCE_APPROVAL = "7",
}

// 勤怠明細取得処理種別
/** 勤怠明細取得処理種別：勤怠管理 */
export const DETAIL_PROCESS_TYPE_ATTENDANCE = "1";
/** 勤怠明細取得処理種別：支払管理 */
export const DETAIL_PROCESS_TYPE_PAYMENT = "2";

/** 勤怠実績ステータス：未提出 */
export const ATTENDANCE_STATUS_NOT_SUBMITTED = "00";
/** 勤怠実績ステータス：差戻 */
export const ATTENDANCE_STATUS_REMAND = "05";
/** 勤怠実績ステータス：確定 */
export const ATTENDANCE_STATUS_DECISION = "10";
/** 勤怠実績ステータス：未承認(提出済み) */
export const ATTENDANCE_STATUS_UNAPPROVED = "20";
/** 勤怠実績ステータス：確認済 */
export const ATTENDANCE_STATUS_CONFIRMED = "25";
/** 勤怠実績ステータス：承認済 */
export const ATTENDANCE_STATUS_APPROVED = "30";

/** 強制承認済フラグ ON */
export const FORCE_APPROVAL_FLAG_ON = '1';
/** 強制承認済フラグ OFF */
export const FORCE_APPROVAL_FLAG_OFF = '0';


// 帳票出力種別
/** 元請：支払実績帳票 */
export const PRIME_REPORT_PAYMENT = "1";
/** 元請：資格保有者帳票 */
export const PRIME_REPORT_QUALIFICATION_HOLDERS = "2";
/** 元請：プロジェクト支払実績帳票 */
export const PRIME_REPORT_PROJECT_QUALIFICATION_HOLDERS = "3";
/** 協力：勤怠実績帳票 */
export const PARTNER_REPORT_ATTENDANCE_DETAIL = "1";
/** 協力：勤怠実績サマリ帳票 */
export const PARTNER_REPORT_ATTENDANCE_SUMMARY = "2";
/** 協力：手当支払い金額確認帳票 */
export const PARTNER_REPORT_PAYMENT = "3";

// 建退共_申請状態
/** 未申請 */
export const OFFER_FLAG_APPROVED = "1";
/** 申請済 */
export const OFFER_FLAG_REQUESTED = "2";
/** 連携済 */
export const OFFER_FLAG_LINKED = "3";

/** 認定状態コード 表示名と1対1にならないので注意（"有効期間外"が認定済みと同じコード） */
export enum CERTIFICATION_STATUS_CODE {
    CERTIFIED = "20"
}
/** 認定状態表示名 */
export enum CERTIFICATION_STATUS {
    CERTIFIED = "認定済"
    , OUTRANGE_DEADLINE = "有効期間外"
}

// コード定義の型定義
interface IConstants {
    [propertyName: string]: { code: string, label: string }
}

// 権限区分
export const AUTHORIZATION_TYPE: IConstants = {
    primeAccessAuth: { code: "10", label: "元請アクセス権限" }
    , primeAvailableAuth: { code: "11", label: "元請利用者" }
    , primeAttendanceApprovalAuth: { code: "12", label: "元請勤怠承認者" }
    , primeAttendanceReffenceRoleAuth: { code: "15", label: "元請勤怠参照役割保持者" }
    , primeAttendanceApprovalRoleAuth: { code: "16", label: "元請勤怠承認役割保持者" }
    , primeSystemMngAuth: { code: "19", label: "元請システム管理者" }
    , partnerAccessAuth: { code: "20", label: "協力アクセス権限" }
    , partnerAvailableAuth: { code: "21", label: "協力請利用者" }
    , partnerAttendanceSubmitAuth: { code: "22", label: "協力勤怠提出者" }
    , partnerSystemMngAuth: { code: "29", label: "協力管理者" }
}

/** 手当区分 */
export const ALLOWANCE_TYPE: IConstants = {
    NONE: { code: "0", label: "なし" }
    , DAILY: { code: "1", label: "日当" }
    , MONTHLY: { code: "2", label: "月手当" }
}

/** 手当条件区分 */
export const ALLOWANCE_INSPECTION_TYPE: IConstants = {
    EXIST: { code: "1", label: "設定あり" }
    , NONE: { code: "0", label: "設定なし" }
}

/** 対象次数 */
export const LEVEL_RANGE_TO: IConstants = {
    TO_5: { code: "5", label: "1～5次" }
    , TO_4: { code: "4", label: "1～4次" }
    , TO_3: { code: "3", label: "1～3次" }
    , TO_2: { code: "2", label: "1～2次" }
    , TO_1: { code: "1", label: "1次のみ" }
    }

/** CCUSレベル */
export const CCUS_LEVEL: IConstants = {
    LEVEL4: { code: "4", label: "レベル４（金）" }
    , LEVEL3: { code: "3", label: "レベル３（銀）" }
    , LEVEL2: { code: "2", label: "レベル２（青）" }
    , LEVEL1: { code: "1", label: "レベル１（白）" }
    }

/** 有効期限有無 */
export const EXIST_DEADLINE: IConstants = {
    NONE: { code: "0", label: "なし" }
    , EXIST: { code: "1", label: "あり" }
}

/** 氏名区分 */
export const NAME_TYPE: IConstants = {
    NAME: { code: "1", label: "氏名" }
    , KANA: { code: "2", label: "氏名カナ" }
    , CCUS_CRAFTSMAN_ID: { code: "3", label: "CCUS技能者ID" }
}

/** 資格要件該当区分 */
export const QUALIFICATION_REQUIREMENT_TYPE: IConstants = {
    NOT_APPLICABLE: { code: "0", label: "該当しない" }
    , APPLICABLE: { code: "1", label: "該当する" }
    , OUTSIDE_VALID_PERIOD: { code: "9", label: "有効期間外" }
}

/** 企業区分 */
export const COMPANY_TYPE: IConstants = {
    PRIME_COMPANY: { code: "1", label: "元請企業" }
    , PARTNER_COMPANY: { code: "2", label: "協力会社" }
    , ACTING_COMPANY: { code: "3", label: "代行企業" }
}

/** 役割 */
export const POSITION_TYPE: IConstants = {
    NONE: { code: "0", label: "役割なし" }
    , LEADER: { code: "1", label: "工事長" }
    , CHIEF: { code: "2", label: "所長" }
    , CHARGE: { code: "3", label: "担当所長" }
    , BUILDING: { code: "4", label: "建築担当" }
    , FACILITY: { code: "5", label: "設備担当" }
    , OFFICEWORK: { code: "6", label: "事務担当" }
    , MEMBER: { code: "7", label: "所員" }
    , SUBCHIEF: { code: "8", label: "副所長" }
    , ENGINEERING: { code: "9", label: "土木担当" }
}

/** 役割別権限 */
export const POSITION_AUTHORITY_TYPE: IConstants = {
    NONE: { code: "", label: "なし" }
    , CONFIRM: { code: "11", label: "確認権限" }
    , APPROVE: { code: "12", label: "承認権限" }
}

/** 締切区分 */
export const CLOSING_DATE_KBN: IConstants = {
    SUBMISSION: { code: "1", label: "提出期限" }
    , APPROVE: { code: "2", label: "承認期限" }
}

/** ワークフローフラグ */
export const WORKFLOW_FLAG: IConstants = {
    OFF: { code: "0", label: "OFF" }
    , ON: { code: "1", label: "ON" }
}

/** 労働時間の自動入力設定 */
export const CALC_WORK_TIME_TYPE: IConstants = {
    NOT_USE: { code: "0", label: "利用しない" }
    , USE: { code: "1", label: "利用する" }
}

/** 労働時間の編集可否設定 */
export const EDITABILITY_WORK_TIME_TYPE: IConstants = {
    NOT_EDITABLE: { code: "0", label: "不可" }
    , EDITABLE: { code: "1", label: "可" }
}

/** 提出可能な協力会社の設定 */
export const SUBMIT_LEVEL_TYPE: IConstants = {
    ALL: { code: "0", label: "全次数（制限なし）" }
    , ONLY_FIRST: { code: "1", label: "一次協力会社のみ" }
}

/** 勤怠重複可否の設定 */
export const ATTENDANCE_PERFORMANCE_DUPLICATE: IConstants = {
    ON: { code: "1", label: "重複入場者の編成選択情報を反映しない" }
    , OFF: { code: "0", label: "重複入場者の編成選択情報を反映する" }
}

/** 建退共連携時の同日複数現場の勤怠集約設定 */
export const MUTUAL_AID_PROJECT_GIVING_POINT_METHOD: IConstants = {
    ALL: { code: "0", label: "集約しない（勤怠を集約せず、現場ごとに建退共へ連携します）" }
    , ANY: { code: "1", label: "集約する（対象となる勤怠を、いずれかの現場に集約して建退共へ連携します）" }
}

/** 手当金額の按分方法 */
export const APPORTIONMENT_TYPE: IConstants = {
    DIVIDE_BY_WORKTIME: { code: "0", label: "手当金額の総額をプロジェクト毎の総労働時間をもとに按分する" }
    , DIVIDE_EQUAL: { code: "1", label: "プロジェクト毎に「日当×労働日数」で算出する" },
}

/**
 * メール種類
 */
export const MAIL_TYPE: IConstants = {
    REQUEST_CONFIRM_ATTENCANCE: { code: "01", label: "勤怠の確認を依頼された場合" }
    , REQUEST_APPROVE_ATTENCANCE: { code: "02", label: "勤怠の承認を依頼された場合" }
    , CANCEL_SUBMIT_ATTENDANCE: { code: "03", label: "勤怠の提出が取り消された場合" }
    , CANCEL_APPROVED_ATTENCANCE: { code: "04", label: "承認済勤怠の承認を取り消した場合" }
    , REMAND_ATTENCANCE: { code: "05", label: "元請会社から差し戻された場合" }
    , APPROVED_ATTENCANCE: { code: "06", label: "元請会社側で承認完了となった場合" }
}

/** メール送信フラグ */
export const MAIL_SEND_FLAG: IConstants = {
    NOT_SEND: { code: "0", label: "通知しない" }
    , SEND: { code: "1", label: "通知する" }
}

// 契約種別
/** 元請企業 */
export const CONTRACT_TYPE_PRIME = "1";
/** 協力会社 */
export const CONTRACT_TYPE_PARTNER = "2";

// 権限管理：管理グループ
/** 管理グループ：全グループ */
export const REFERENCE_RANGE_ALL = "1";
/** 管理グループ：グループ指定 */
export const REFERENCE_RANGE_POINT = "2";

// 権限管理：権限区分名
/** 権限管理：すべての権限 */
export const AUTHORITY_ALL = "すべての権限";
/** 権限管理：利用者 */
export const AUTHORITY_AVAILABLE_AUTH = "利用者";
/** 権限管理：勤怠承認者 */
export const AUTHORITY_ATTENDANCE = "勤怠承認者";
/** 権限管理：管理者 */
export const AUTHORITY_SYSTEM = "管理者";
/** 権限管理：勤怠提出者 */
export const AUTHORITY_ATTENDANCE_SUMBIT = "勤怠提出者";

// メッセージ種別
/** 成功*/
export const MESSAGE_TYPE_SUCCESS = "1";
/** エラー*/
export const MESSAGE_TYPE_ERROR = "2";

// 編集可能フラグ
/** 編集可能フラグ：編集不可 */
export const EDIT_AVAILABLE_FLAG_NOT_AVAILABLE = 0;
/** 編集可能フラグ：編集可能 */
export const EDIT_AVAILABLE_FLAG_AVAILABLE = 1;

/** 承認可能フラグ：編集不可 */
export const APPROVE_AVAILABLE_FLAG_NOT_AVAILABLE = 0;
/** 承認可能フラグ：編集可能 */
export const APPROVE_AVAILABLE_FLAG_AVAILABLE = 1;


// 廃止企業フラグ
/** 廃止企業フラグ ON */
export const ABOLISH_COMPANY_FLAG_ON = '1';
/** 廃止企業フラグ OFF */
export const ABOLISH_COMPANY_FLAG_OFF = '0';

/** プライムサービス契約情報 */
export enum CONTRACT_PRIME_SERVICE {
    /** 契約 */
    CONTRACT = "1",
    /** 未約 */
    NOT_CONTRACT = "0"
}

/** 協力会社の帳票出力で出力する勤怠件を絞り込む */
export enum OUTPUT_REPORT_APPROVED_ONLY_FLAG {
    OUTPUT_ALL_ATTENDANCE = "0"
    , OUTPUT_ONLY_APPROVED_ATTENDANCE = "1"
}

/** 退職済フラグ */
export enum RETIRED_FLAG {
    /** 退職済 */
    RETIRED = "1",
    /** 雇用中 */
    NOT_RETIRED = "0"
}

/**
 * 「対象月内に入退場／労働時間のいずれもない作業員を除く」のチェックON/OFF
 */
export enum HAS_IN_OUT_WORK_TIME_CHECK {
    ON = "1",
    OFF = "0"
}

/**
 * 入退場／労働時間記録を持つか
 */
export enum HAS_IN_OUT_WORK_TIME {
    /** 有 */
    HAVING = "1",
    /** 無 */
    NOT_HAVING = "0"
}

/**
 * アラート非表示
 */
export enum HIDDEN_ALERT {
    /** 編集禁止 */
    NotEditable = 0,
    /** 勤怠重複 */
    AttendanceDuplicate = 1
}

/**
 * 技能レベル適用フラグ
 */
export enum CCUS_FLAG {
    /** CCUS資格 */
    ON = "1",
    /** 独自資格 */
    OFF = "0"
}

/**
 * CCUS同意状態
 */
export enum CCUS_CONSENT {
    /** 同意 */
    ON = "1",
    /** 未同意 */
    OFF = "0"
}

/**
 * CCUSエラーフラグ
 */
export enum CCUS_ERROR_FLAG {
    /** エラーあり */
    ON = "1",
    /** エラーなし */
    OFF = "0"
}

/** 建退共所持フラグ */
export enum MUTUAL_AID_FLAG {
    ON = "1", // あり
    OFF = "0" // なし
}

/** 建退共連携処理種別 */ 
export enum MUTUAL_AID_PROCESS_TYPE {
    /** 勤怠処理種別：申請 */
    REQUEST = "1",
    /** 勤怠処理種別：差戻 */
    REMAND = "2",
}

/** 企業担当者フラグ */
export enum MANAGER_FLAG {
    USER = '1', // 一般ユーザー
    COMPANY_STAFF = '2', // 企業担当者
    COMPANY_SUB_STAFF = '3', // 企業サブ担当者
    SYSTEM_ADMIN = '4', // 管理者
    HELP_DESK = '5', // ヘルプデスク
    MCDP_STAFF = '6' // MCDP運用担当者
}

/** 同意状況区分 */
export enum MUTUAL_AID_AGREEMENT_STATE_TYPE {
  HOLD = '0', // 保留
  DISAGREE = '1', // 不同意
  AGREE = '2', // 同意
  CONFIRM_AGREE = '3', // 再同意要
}

/** 建退共連携エラーレポート処理種別 */ 
export enum MUTUAL_AID_ERROR_REPORT_PROCESS_TYPE {
    /** エラーなし */
    NO_ERROR = "1",
    /** エラーなし解除 */
    NO_ERROR_RELEASE = "2",
    /** エラーレポート削除 */
    ATTACH_DELETE = "3",
}
